import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import moment from 'moment'
import { extendObservable, action } from 'mobx'
import enhanceWithClickOutside from 'react-click-outside'
import PropTypes from 'prop-types'
import DateRangeIcon from '@material-ui/icons/DateRange'

import WidgetBox from '../WidgetBox'
import MonthYearCalendar from '@components/MonthPicker/MonthYearCalendar'

import Tooltip from '@components/Tooltip'

class Performance extends Component {
  static propTypes = {
    dashboardStore: PropTypes.object,
    performanceData: PropTypes.object,
    activeTeamId: PropTypes.number,
    setDate: PropTypes.func,
    date: PropTypes.string
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      isCalendarShown: false
    })

    this.datePicker = null
  }

  handleCalendarDisplay = () => {
    this.isCalendarShown = true
  }

  handleClickOutside = () => {
    this.closeCalendar()
  }

  closeCalendar = () => {
    this.isCalendarShown = false
  }

  handleDateChange = action(date => {
    const { getPerformanceWidgetData } = this.props.dashboardStore
    this.props.setDate(date)
    const newDate = moment(date).format('MM-YYYY')
    !this.props.activeTeamId
      ? getPerformanceWidgetData(newDate)
      : getPerformanceWidgetData(newDate, this.props.activeTeamId)
  })

  onMonthPress = monthAndYear => {
    this.isCalendarShown = false
    this.handleDateChange(monthAndYear)
  }

  render () {
    if (!this.props.performanceData) return null

    const data = this.props.performanceData

    const date = this.props.date
    return (
      <WidgetBox
        label='Performance'
        action={
          <div>
            <div className='widget-box__top-bar__action--opacity'>
              <button
                className='performance-widget__datepicker'
                onClick={this.handleCalendarDisplay}
              >
                <DateRangeIcon />
                <div className='datepicker-text'>{date}</div>
              </button>
            </div>
          </div>
        }
      >
        <div className='performance-widget'>
          <table className='widget-table'>
            <thead>
              <tr>
                <th />
                <th className='performance-header'>Deliveries</th>
                <th className='performance-header'>Interviewed</th>
              </tr>
            </thead>
            <tr className='performance-row'>
              <td>
                <Tooltip tooltip='Delivered by me'>
                  <span className='performance-text'>Delivered by me</span>
                </Tooltip>
              </td>
              <td>{data.employeeDeliveries}</td>
              <td>{data.employeeInterviews}</td>
            </tr>
            <tbody>
              <tr className='performance-row'>
                <td>
                  <span className='performance-text'>My total</span>
                </td>
                <td>
                  {data.accountManagerDeliveries +
                    data.teamLeaderDeliveries +
                    data.employeeDeliveries}
                </td>
                <td>
                  {data.accountManagerInterviews +
                    data.teamLeaderInterviews +
                    data.employeeInterviews}
                </td>
              </tr>
              <tr className='performance-row'>
                <td>
                  <span className='performance-text'>
                    <Tooltip tooltip={`Team -  ${data.teamName}`}>
                      <span>Team - {data.teamName}</span>
                    </Tooltip>
                  </span>
                </td>
                <td>{data.teamDeliveries}</td>
                <td>{data.teamInterviews}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {this.isCalendarShown && (
          <MonthYearCalendar
            closeCalendar={this.closeCalendar}
            activeMonthAndYear={date}
            onMonthPress={this.onMonthPress}
          />
        )}
      </WidgetBox>
    )
  }
}

export default inject(
  'userStore',
  'dashboardStore'
)(enhanceWithClickOutside(observer(Performance)))
